import React from 'react';
import { formatDateMMDDYYPacific } from '../../../utilities/dateHelpers';
import { colors } from '../../../constants';
import { CheckBoxIcon, ExclamationWarningIcon } from '../../../icons';

const TargetSummary = ({ index, tgtTimeStamp, targetData }) => {
    const { securedActual, securedGoal } = targetData;
    const tgt = new Date(tgtTimeStamp);
    const today = new Date();

    const getStatusIcon = () => {
        return securedActual >= securedGoal ? (
            <CheckBoxIcon color={colors.aroGreen} />
        ) : tgt < today ? (
            <ExclamationWarningIcon color={colors.aroRed} />
        ) : (
            <ExclamationWarningIcon />
        );
    };

    return (
        <div className="d-flex flex-column flex-lg-row gap-1 gap-lg-4 align-items-center justify-content-center">
            <div>{getStatusIcon()}</div>
            <div>
                <div className="acquisitions-dashboard-table-label">
          Acquisition {index + 1}
                </div>
                <div className="fst-italic" style={{ fontSize: '.875rem' }}>
          Sale by {formatDateMMDDYYPacific(tgt)}
                    <br />
                    {securedActual} of {securedGoal} Secured
                </div>
            </div>
        </div>
    );
};

export default TargetSummary;
